// extracted by mini-css-extract-plugin
var _1 = "DqD45E6Op1c74qFginP0";
export { _1 as "container" }
